import * as React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
// import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { CircularProgress } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  backgroundColor: "transparent !important",
  // padding: "10px 13px !important",
  // padding: theme.spacing(2),
  textAlign: "center",
  // color: theme.palette.text.secondary,
}));

const theme = createTheme();

theme.typography.h4 = {
  fontSize: "28px",
  "@media (min-width:600px)": {
    fontSize: "34px",
  },
};
theme.typography.h6 = {
  fontSize: "17px",
  "@media (min-width:600px)": {
    fontSize: "18px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "18px",
  },
};
theme.typography.body1 = {
  fontSize: "18px",
  "@media (min-width:600px)": {
    fontSize: "22px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "22px",
  },
};

const SingleProjectCard = ({ singleprojectlist, isLoading }) => {
  return (
    <Grid item xs={12} sm={12} md={12}>
                {isLoading && <CircularProgress />}
      <ThemeProvider theme={theme}>
      <Typography
              variant="h4"
              className="cardtextwhite"
              sx={{ textAlign: "center",  pb:2  }}
            >
              {singleprojectlist?.title}
            </Typography>
            {/* <Divider variant="middle" /> */}
        <Card className="CardBG customboxshadow" sx={{ boxShadow: 4}}>
          {/* <Link to={url}>Details</Link> */}
          <CardMedia
            height= "auto"
            width="100%"
            component="img"
            sx={{ mx: "auto" }}
            image={singleprojectlist?.image}
            alt="green iguana"
          />
          <CardContent>
            <Typography
              variant="body1"
              color="text.primary"
              className="cardtextwhite"
              sx={{ pb: 2 }}
            >
              {singleprojectlist?.description}
              {/* {singleprojectlist?.description.slice(0, 200)} */}
            </Typography>
            <Typography
              variant="h6"
              className="cardtextwhite bordercolor"
              // className="cardtextwhite button-beguni"
              sx={{ textAlign: "center", py: 1, mb: 3 }}
            >
              {singleprojectlist?.technologies}
            </Typography>
          </CardContent>

          <CardContent>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs>
                  <Item>
                    {" "}
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      target="_blank"
                      href={singleprojectlist?.visit}
                      rel="noreferrer"
                    >
                      <Button  variant="contained">
                        LIVE DEMO
                      </Button>
                    </a>
                  </Item>
                </Grid>
                <Grid item xs>
                  <Item>
                    {" "}
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      target="_blank"
                      href={singleprojectlist?.client}
                      rel="noreferrer"
                    >
                      <Button variant="contained">
                        CLIENT CODE
                      </Button>
                    </a>
                  </Item>
                </Grid>
                {singleprojectlist?.server && (
                  <Grid item xs>
                    <Item>
                      {" "}
                      <a
                        style={{ textDecoration: "none", color: "white" }}
                        target="_blank"
                        href={singleprojectlist?.server}
                        rel="noreferrer"
                      >
                        <Button  variant="contained">
                          SERVER CODE
                        </Button>
                      </a>
                    </Item>
                  </Grid>
                )}
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </ThemeProvider>
    </Grid>
  );
};

export default SingleProjectCard;
